var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2061_920)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39851 40.9774C3.88863 41.044 2.83372 39.975 2.83372 39.975L0.89667 38.0317C0.89667 38.0317 -0.00386203 36.9442 1.24666e-05 35.6228C0.00388697 34.3013 1.04163 33.167 1.04163 33.167L29.5958 4.52085C29.5958 4.52085 30.2362 3.97816 30.6689 3.81362C30.7256 3.79206 30.7787 3.77124 30.8295 3.75127L30.8296 3.75124C31.1669 3.61885 31.4076 3.52438 31.9714 3.50509C32.6203 3.48289 33.2557 3.68635 33.5982 3.83654C33.9407 3.98674 34.5606 4.5062 34.5606 4.5062L35.8923 6.0513L63.0943 33.2951C63.0943 33.2951 64.0212 34.3802 63.9996 35.7199C63.9781 37.0596 63.0174 38.0655 63.0174 38.0655L61.1764 39.9319C61.1764 39.9319 60.0682 40.975 58.702 40.9778C57.3359 40.9805 56.2143 39.9418 56.2143 39.9418L54.4802 38.2008L54.4805 56.9556C54.4805 56.9556 54.5084 58.4193 53.5362 59.4094C52.5641 60.3995 51.0044 60.4958 51.0044 60.4958L12.849 60.4961C12.849 60.4961 11.1455 60.277 10.2865 59.4094C9.42745 58.5418 9.27542 56.8868 9.27542 56.8868V38.3979L7.81006 39.868C7.81006 39.868 6.9084 40.9107 5.39851 40.9774Z",
    fill: "#4200FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9795,
    y: 24.3081,
    width: 38.1826,
    height: 23.9161,
    rx: 5.63226,
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3184,
    y: 30.9512,
    width: 5.85174,
    height: 10.6294,
    rx: 2.61966,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8018 37.7422C35.8018 37.7422 36.9258 34.7896 39.3128 34.7896C41.6998 34.7896 42.8238 37.7422 42.8238 37.7422",
    stroke: "white",
    strokeWidth: 1.96474,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1144 52.5397C33.4616 52.5397 34.2069 52.0658 34.7955 51.6732C35.384 51.2807 35.8077 50.6797 36.2068 50.5347C36.6059 50.3897 36.8134 50.3679 37.3059 50.7608C37.7983 51.1538 37.651 51.8928 37.651 51.8928C37.651 51.8928 37.1146 53.3063 35.798 54.336C34.4815 55.3657 33.6315 55.6646 32.2381 55.6646C30.8447 55.6646 29.6701 55.3435 28.2882 54.2151C26.9064 53.0868 26.6967 52.3868 26.5005 51.8928C26.3043 51.3987 26.6096 50.9958 26.9163 50.7608C27.2229 50.5258 27.6689 50.3877 28.1428 50.6487C28.6167 50.9097 28.5137 51.1567 29.353 51.6732C30.1923 52.1898 30.7672 52.5397 32.1144 52.5397Z",
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0635 54.3927C32.7907 54.3927 33.193 54.2416 33.5106 54.1164C33.8283 53.9912 34.057 53.7996 34.2724 53.7533C34.4878 53.7071 34.5998 53.7002 34.8656 53.8255C35.1314 53.9508 35.0519 54.1864 35.0519 54.1864C35.0519 54.1864 34.7623 54.6372 34.0517 54.9656C33.3411 55.294 32.3969 55.3577 32.3969 55.3577H31.6071C31.6071 55.3577 30.7442 55.2869 29.9984 54.9271C29.2526 54.5672 29.1394 54.344 29.0335 54.1864C28.9276 54.0289 29.0924 53.9004 29.2579 53.8255C29.4234 53.7505 29.6641 53.7065 29.9199 53.7897C30.1757 53.8729 30.1201 53.9517 30.5731 54.1164C31.0261 54.2812 31.3364 54.3927 32.0635 54.3927Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2061_920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.110fca7ed81f13cc2a180045db1f2d15.svg";
export { ForwardRef as ReactComponent };